// I18n
import { i18next, initReactI18next, resources } from "@/lib/i18n"

// Env variables
import { DEBUG_I18N } from "@/lib/env"

// Logging
import { addBreadcrumb } from "@/lib/sentry"

// State
import { store } from "@/state/store"
const DETECTED_LANGUAGE = store.getState().userPreferences.lang

/**
 * initI18n
 * @returns
 */
export const initI18n = () => {
	return (
		i18next
			// pass the i18n instance to react-i18next.
			.use(initReactI18next)
			.init({
				debug: DEBUG_I18N === "true",
				ns: ["common"],
				fallbackLng: DETECTED_LANGUAGE,
				defaultNS: "common",

				resources,

				/**
				 * Namespace and key seperators
				 *
				 * NOTE: Previously, we did not use namespaced keys.
				 * Instead we treat first part of key as a namespace, e.g. "namespace.this.is_a_key".
				 *
				 * TODO: Can be refactored with ":" + ".". This allows for better integration with existing i18n tools.
				 *
				 * EXAMPLE: project:project.revenue.table.headers.interest_period
				 */
				nsSeparator: ":",
				keySeparator: ".",

				lng: DETECTED_LANGUAGE,

				interpolation: {
					// react is already safe from xss
					escapeValue: false,
				},
				saveMissing: true,
				missingKeyHandler: (
					ngs,
					ns,
					key,
					fallbackValue,
					updateMissing,
					options,
				) => {
					// Add Sentry breadcrumb
					addBreadcrumb({
						category: "i18n",
						message: "Missing i18n key",
						data: {
							ngs,
							ns,
							key,
							fallbackValue,
							updateMissing,
							options,
						},
					})

					// Add Sentry breadcrumb
					console.warn("Missing i18n key", {
						ngs,
						namespace: ns,
						key,
						fallbackValue,
						updateMissing,
						options,
					})
				},
			})
	)
}

export { i18next }
